// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#global-edition-region-reset-button-container form{all:unset}", "",{"version":3,"sources":["webpack://./src/templates/globalEdition/RegionResetButton/style.scss"],"names":[],"mappings":"AACE,mDACE,SAAA","sourcesContent":["#global-edition-region-reset-button-container {\n  form {\n    all: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
